/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { RelatedFootageReasonFromJSON, RelatedFootageReasonToJSON, } from './RelatedFootageReason';
/**
 * Check if a given object implements the RelatedIncidentReportDto interface.
 */
export function instanceOfRelatedIncidentReportDto(value) {
    let isInstance = true;
    return isInstance;
}
export function RelatedIncidentReportDtoFromJSON(json) {
    return RelatedIncidentReportDtoFromJSONTyped(json, false);
}
export function RelatedIncidentReportDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : json['incidentReportType'],
        'incidentDateTime': !exists(json, 'incidentDateTime') ? undefined : (new Date(json['incidentDateTime'])),
        'incidentTimezone': !exists(json, 'incidentTimezone') ? undefined : json['incidentTimezone'],
        'suburb': !exists(json, 'suburb') ? undefined : json['suburb'],
        'thumbnailUrl': !exists(json, 'thumbnailUrl') ? undefined : json['thumbnailUrl'],
        'reason': !exists(json, 'reason') ? undefined : RelatedFootageReasonFromJSON(json['reason']),
    };
}
export function RelatedIncidentReportDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'incidentReportType': value.incidentReportType,
        'incidentDateTime': value.incidentDateTime === undefined ? undefined : (value.incidentDateTime.toISOString()),
        'incidentTimezone': value.incidentTimezone,
        'suburb': value.suburb,
        'thumbnailUrl': value.thumbnailUrl,
        'reason': RelatedFootageReasonToJSON(value.reason),
    };
}
